import { useEffect, useRef, useState } from "react";

export type EstadoRed = "conectado" | "sin-red" | "recuperada";
const RECUPERADA_MS = 3000;

/** `conectado` → `sin-red` al caer; al volver pasa 3 s por `recuperada` («Conectado de nuevo.») y vuelve a `conectado`. */
export function useOnlineStatus(): EstadoRed {
  const [estado, setEstado] = useState<EstadoRed>(() => (typeof navigator !== "undefined" && navigator.onLine === false ? "sin-red" : "conectado"));
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    const caida = () => {
      clearTimeout(timer.current);
      setEstado("sin-red");
    };
    const vuelta = () => {
      setEstado((previo) => (previo === "sin-red" ? "recuperada" : previo));
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setEstado("conectado"), RECUPERADA_MS);
    };
    window.addEventListener("offline", caida);
    window.addEventListener("online", vuelta);
    return () => {
      window.removeEventListener("offline", caida);
      window.removeEventListener("online", vuelta);
      clearTimeout(timer.current);
    };
  }, []);

  return estado;
}
